module.exports = __webpack_public_path__ + "img/upload.06aafab1.svg";